@if (file) {
  @if (file.fileType == FileTypeEnum.PDF) {
    <app-pdfviewer [fileName]="file.name!" [url]="file.link!"></app-pdfviewer>
  }

  <!-- Ein Koordinationsmodell wird ueber seine eigene Id geoeffnet; primaryModel traegt dann die
       erste verknuepfte Datei (siehe FileViewerComponent). -->
  @if (primaryModel && (file.fileType == FileTypeEnum.IFC || file.fileType == FileTypeEnum.COORDINATION)) {
    <app-bim-viewer [additionalModels]="additionalIfcModels"
                    [primaryModel]="primaryModel"
                    [title]="file.name!"></app-bim-viewer>
  }

}
